import { useNavigate, useSearchParams } from 'react-router-dom'

/**
 * Navigation utility to preserve user_id across all routes
 */
export const useNavigationWithUserId = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  
  const userId = searchParams.get('user_id')
  
  const navigateWithUserId = (path, options = {}) => {
    const finalPath = userId ? `${path}?user_id=${userId}` : path
    console.log('Navigation with user_id:', { path, finalPath, userId })
    navigate(finalPath, options)
  }
  
  const navigateToCustomer = (subPath = '', options = {}) => {
    const path = subPath ? `/customer/${subPath}` : '/customer'
    navigateWithUserId(path, options)
  }
  
  const navigateToAdmin = (subPath = '', options = {}) => {
    const path = subPath ? `/admin/${subPath}` : '/admin'
    navigateWithUserId(path, options)
  }
  
  const navigateToEmployee = (subPath = '', options = {}) => {
    const path = subPath ? `/employee/${subPath}` : '/employee'
    navigateWithUserId(path, options)
  }
  
  return {
    navigateWithUserId,
    navigateToCustomer,
    navigateToAdmin,
    navigateToEmployee,
    userId
  }
}

export default useNavigationWithUserId
